/* ============================================================
   COLLECTION 3599 — UPDATIONS   (v8)
   ------------------------------------------------------------
   UPDATE 1 — One Size "Fits" note
   UPDATE 2 — Product labels, assigned manually per product

   ══ THE RULE ══
   Nothing renders unless the CURRENT COLLECTION ID is in
   GATE.ALLOWED_IDS. No ID detected → nothing. ID not in the
   list → nothing. There is no fallback, no guessing.

   WHAT CHANGED IN v8
     • GATE IS CHECKED AT EVERY ENTRY POINT — init, the AJAX
       sort/filter listeners, scan, observeCard, processCard and
       render. In v6 and earlier the sort/filter listeners called
       scan() directly with NO gate check, which is why labels
       appeared on other collections the moment you sorted.
     • Gate result is re-read on every call (not cached), because
       the collection can change without a page load.
     • ID-ONLY matching. Handles are gone — an ID is exact.
     • render() injects styles defensively. Previously, if the
       gate blocked at boot the stylesheet was never created, so
       a label forced in later rendered as a raw full-width block
       bar with no CSS behind it. That can no longer happen.
     • Structural CSS is also written inline on the element.
     • DUPLICATE GUARD — a stale second copy of this file aborts
       loudly instead of fighting the new one.
     • Full DESKTOP / MOBILE split for position, size, spacing
       and colours.

   ⚠ This file sets ONLY width/height/font-size on the badge. It
     must NOT touch display, position, or anything inside
     .pc-badge-text-on-img — product-card.js retypes that text on
     a perpetual timer and layout changes break the animation.
     Set SCALE_BADGE to false to leave the badge fully alone.

   TROUBLESHOOTING (console, on the collection page)
       Collection3599.where();      // id + allowed + live count
       Collection3599.clearCache();
       Collection3599.debug();      // per-card label table
   ============================================================ */
(function () {
  'use strict';

  var BUILD = 'v8';

  /* ─────────── DUPLICATE GUARD ─────────── */
  if (window.__C3599_BUILD__) {
    console.warn(
      '[C3599] ABORTED — build ' + BUILD + ' loaded but build ' +
      window.__C3599_BUILD__ + ' is already running. An old copy of ' +
      'this file is still on the page (stale cached asset, or a ' +
      'duplicate paste in a Custom Liquid block / theme.liquid). ' +
      'Remove it, then hard-refresh.'
    );
    return;
  }
  window.__C3599_BUILD__ = BUILD;

  /* ─────────── DEBUG ─────────── */
  var DEBUG = false;          // ← true to log every rule evaluation
  var ANNOUNCE_GATE = true;   // ← one console line when the gate blocks

  function log() {
    if (!DEBUG) return;
    console.log.apply(console, ['[C3599]'].concat([].slice.call(arguments)));
  }


  /* ════════════════════════════════════════════════════════════
     COLLECTION GATE  —  ID ONLY
     ------------------------------------------------------------
     Put the numeric collection ID of every collection where the
     labels SHOULD appear. Anything not listed gets nothing.

     To find an ID: open the collection in Shopify admin and read
     the number at the end of the URL, or run this in the console
     on the storefront collection page:
         ShopifyAnalytics.meta.page.resourceId
     ════════════════════════════════════════════════════════════ */
  var GATE = {

    ALLOWED_IDS: [
      '597085290660',
      '598798008484'

    
      // '678553911460',
    ]

  };

  /* Read the current page fresh every time — a sort or filter can
     swap content without a page load. */
  function pageInfo() {
    var info = { type: '', id: '' };

    /* Source A — Shopify analytics meta (most reliable) */
    try {
      var m = window.ShopifyAnalytics
           && window.ShopifyAnalytics.meta
           && window.ShopifyAnalytics.meta.page;
      if (m) {
        if (m.pageType)   info.type = String(m.pageType);
        if (m.resourceId) info.id   = String(m.resourceId);
      }
    } catch (e) {}

    /* Source B — Shopify tracking object (fallback for the ID) */
    try {
      if (window.__st) {
        if (!info.type && window.__st.p)   info.type = String(window.__st.p);
        if (!info.id   && window.__st.rid) info.id   = String(window.__st.rid);
      }
    } catch (e) {}

    return info;
  }

  var gateAnnounced = false;

  /* THE ONE CHECK. Called from every entry point. */
  function collectionAllowed() {
    var p = pageInfo();

    /* Must be a collection page */
    if (p.type && p.type !== 'collection') { announce(p, 'not a collection page'); return false; }

    /* Must have an ID */
    if (!p.id) { announce(p, 'no collection ID found'); return false; }

    /* Must be in the list */
    var want = String(p.id).trim();
    for (var i = 0; i < GATE.ALLOWED_IDS.length; i++) {
      if (String(GATE.ALLOWED_IDS[i]).trim() === want) {
        log('gate PASSED — id:', want);
        return true;
      }
    }

    announce(p, 'ID not in ALLOWED_IDS');
    return false;
  }

  function announce(p, why) {
    if (!ANNOUNCE_GATE || gateAnnounced) return;
    gateAnnounced = true;
    console.log(
      '[C3599 ' + BUILD + '] gate BLOCKED (' + why + ') — type:' +
      (p.type || '?') + ' id:' + (p.id || '?') +
      '. Nothing from this file will render here, including after ' +
      'sort or filter. If you still see labels, they come from ' +
      'somewhere else.'
    );
  }


  /* ════════════════════════════════════════════════════════════
     UPDATE 1 — One Size "Fits" note
     ------------------------------------------------------------
     Appends a note beside the size button in the quick-add
     overlay, ONLY when the overlay has exactly ONE size option
     and it is a one-size / free-size value.
     ════════════════════════════════════════════════════════════ */
  var U1 = (function () {

    var CONFIG = {

      NOTE_TEXT: 'Fits S - 6XL',

      /* ══ COLOURS ══ */
      COLOR_DESKTOP: '#1a1a1a',
      COLOR_MOBILE:  '#1a1a1a',

      /* ══ SIZE + GAP — clamp(MIN, CQW, MAX) ══
         cqw = 1% of the CARD width, not the viewport */
      DESKTOP: {
        SIZE_MIN: '10px', SIZE_CQ: '4.5cqw', SIZE_MAX: '13px',
        GAP_MIN:  '4px',  GAP_CQ:  '3cqw',   GAP_MAX:  '12px'
      },

      MOBILE: {
        SIZE_MIN: '8px',  SIZE_CQ: '4cqw',   SIZE_MAX: '11px',
        GAP_MIN:  '3px',  GAP_CQ:  '2.5cqw', GAP_MAX:  '8px'
      },

      /* Fallbacks where container queries aren't supported */
      FALLBACK_FS_DESKTOP:  'clamp(9px,2vw,13px)',
      FALLBACK_GAP_DESKTOP: 'clamp(4px,1.2vw,12px)',
      FALLBACK_FS_MOBILE:   'clamp(7px,2.6vw,11px)',
      FALLBACK_GAP_MOBILE:  'clamp(3px,1.5vw,8px)',

      /* ══ TYPE ══ */
      FONT_FAMILY: '"Montserrat", sans-serif',
      WEIGHT:      '700',
      ITALIC:      false,
      TRACKING:    '0em',
      LINE_HEIGHT: '1.2',

      /* ══ BREAKPOINT ══ */
      MOBILE_BREAKPOINT: '749px',

      /* ══ ANIMATION ══ */
      FADE_MS: 220
    };

    var STYLE_ID = 'c3599-onesize-note-styles-' + BUILD;

    function cl(min, mid, max) {
      return 'clamp(' + min + ',' + mid + ',' + max + ')';
    }

    function injectStyles() {
      if (document.getElementById(STYLE_ID)) return;

      var C = CONFIG;

      var fsD  = cl(C.DESKTOP.SIZE_MIN, C.DESKTOP.SIZE_CQ, C.DESKTOP.SIZE_MAX);
      var gapD = cl(C.DESKTOP.GAP_MIN,  C.DESKTOP.GAP_CQ,  C.DESKTOP.GAP_MAX);
      var fsM  = cl(C.MOBILE.SIZE_MIN,  C.MOBILE.SIZE_CQ,  C.MOBILE.SIZE_MAX);
      var gapM = cl(C.MOBILE.GAP_MIN,   C.MOBILE.GAP_CQ,   C.MOBILE.GAP_MAX);

      var BP = '@media (max-width:' + C.MOBILE_BREAKPOINT + ')';

      var css =
        '.pc-ov-sizes{align-items:center;}' +

        '.c3599-fits-note{' +
          '--c3599n-fs:' + C.FALLBACK_FS_DESKTOP + ';' +
          '--c3599n-gap:' + C.FALLBACK_GAP_DESKTOP + ';' +
          '--c3599n-color:' + C.COLOR_DESKTOP + ';' +
          'display:inline-flex !important;align-items:center;' +
          'margin-left:var(--c3599n-gap);' +
          'color:var(--c3599n-color);' +
          'font-family:' + C.FONT_FAMILY + ';' +
          'font-size:var(--c3599n-fs);' +
          'font-weight:' + C.WEIGHT + ';' +
          'font-style:' + (C.ITALIC ? 'italic' : 'normal') + ';' +
          'letter-spacing:' + C.TRACKING + ';' +
          'line-height:' + C.LINE_HEIGHT + ';' +
          'white-space:nowrap;pointer-events:none;' +
          'opacity:0;transform:translateX(-4px);' +
          'transition:opacity ' + C.FADE_MS + 'ms ease, transform ' + C.FADE_MS + 'ms ease;' +
        '}' +
        '.c3599-fits-note.is-in{opacity:1;transform:translateX(0);}' +

        BP + '{' +
          '.c3599-fits-note{' +
            '--c3599n-fs:' + C.FALLBACK_FS_MOBILE + ';' +
            '--c3599n-gap:' + C.FALLBACK_GAP_MOBILE + ';' +
            '--c3599n-color:' + C.COLOR_MOBILE + ';' +
          '}' +
        '}' +

        '@supports (container-type:inline-size){' +
          '@container c3599card (min-width:0px){' +
            '.c3599-fits-note{--c3599n-fs:' + fsD + ';--c3599n-gap:' + gapD + ';}' +
          '}' +
          BP + '{' +
            '@container c3599card (min-width:0px){' +
              '.c3599-fits-note{--c3599n-fs:' + fsM + ';--c3599n-gap:' + gapM + ';}' +
            '}' +
          '}' +
        '}' +

        '@media (prefers-reduced-motion: reduce){' +
          '.c3599-fits-note{transition:none;opacity:1;transform:none;}' +
        '}';

      var tag = document.createElement('style');
      tag.id = STYLE_ID;
      tag.appendChild(document.createTextNode(css));
      document.head.appendChild(tag);
    }

    function normalize(str) {
      return String(str || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    function isOneSizeValue(val) {
      var n = normalize(val);
      return n === 'onesize' || n === 'freesize' ||
             n === 'onesizefitsall' || n === 'os' || n === 'fs';
    }

    function processSizeRow(row) {
      if (!collectionAllowed()) return;          // ← gate
      if (!row || row._c3599FitsDone) return;

      var btns = row.querySelectorAll('.pc-ov-size-btn');
      if (btns.length !== 1) { row._c3599FitsDone = true; return; }

      var btn = btns[0];
      var val = btn.getAttribute('data-val') || btn.textContent || '';
      if (!isOneSizeValue(val)) { row._c3599FitsDone = true; return; }

      if (row.querySelector('.c3599-fits-note')) { row._c3599FitsDone = true; return; }

      injectStyles();                            // ← never render unstyled

      var note = document.createElement('span');
      note.className = 'c3599-fits-note';
      note.textContent = CONFIG.NOTE_TEXT;

      /* inline safety net — never a full-width block */
      note.style.display = 'inline-flex';
      note.style.pointerEvents = 'none';

      row.appendChild(note);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () { note.classList.add('is-in'); });
      });

      row._c3599FitsDone = true;
    }

    function scan(target) {
      if (!collectionAllowed()) return;          // ← gate
      if (!target || target.nodeType !== 1) return;

      if (target.classList && target.classList.contains('pc-ov-sizes')) {
        processSizeRow(target);
        return;
      }

      if (!target.querySelectorAll) return;
      var rows = target.querySelectorAll('.pc-ov-sizes');
      for (var i = 0; i < rows.length; i++) processSizeRow(rows[i]);
    }

    function init() {
      if (!collectionAllowed()) return;          // ← gate
      injectStyles();
      scan(document.body);
    }

    return { init: init, scan: scan, config: CONFIG };
  })();


  /* ════════════════════════════════════════════════════════════
     UPDATE 2 — Product labels (manual assignment)
     ------------------------------------------------------------
     ONE label per card. PRIORITY decides when an ID sits in more
     than one list. LABEL_COLLECTIONS can narrow a single label
     to specific collections within the allowed set.
     ════════════════════════════════════════════════════════════ */
  var U2 = (function () {

    var CONFIG = {

      /* 'id'     — match on product ID (one fetch per card)
         'handle' — match on product handle (NO fetch, instant) */
      MATCH_BY: 'id',

      /* ══ ASSIGN PRODUCTS TO LABELS ══ */
      ASSIGN: {

        bestseller: [
          '10356496466084',   //  1 · Orange Ethnic Print
          '10330327154852',   //  2 · Teal Blue Ethnic Printed
          '8734148165796',    //  3 · Teal Blue Ethnic Print
          '10330327187620',   //  4 · Indigo Ethnic Printed
          '10330327220388',   //  5 · Turquoise Blue Ethnic Print
          '8264720253092',    //  6 · Indigo Multi Ethnic Motifs Printed
          '8407313219748',    //  7 · Indigo Multi Ethnic Motifs Print
          '10330327122084',   //  8 · Mauve Ethnic Print
          '10330327318692',   //  9 · Turquoise Multi Ethnic Print
          '8525667631268'     // 10 · Yellow Multi Floral Print
        ],

        soldout: [
          // '0000000000000',
        ],

        new: [
          '10344312144036',   // 11 · Purple Green Ethnic Print Cotton
          '8627033964708',    // 12 · Mustard Ethnic Motifs Print
          '8264720220324',    // 14 · Black Ethnic Print
          '8264719761572',    // 17 · Blue Multi Floral Print
          '8734148198564',    // 19 · Green Multi Ethnic Print
          '8214754754724',    // 22 · Blue Cotton Animal Print
          '8525667795108',    // 24 · Green Multi Floral Print
          '8525667565732',    // 27 · Olive Green Multi Floral Print
          '8162229813412',    // 30 · Navy Blue Multi Ethnic Print
          '10344312209572',   // 33 · Turquoise Multi Tropical Print Cotton
          '8627034325156',    // 35 · Teal White Geometric Print
          '8214754820260',    // 36 · Pink Cotton Ethnic Print
          '8734148231332',    // 39 · Brown Multi Ethnic Print
          '10267449098404',   // 41 · Cream High-Rise Trouser
          '10344312242340',   // 43 · Wine White Floral Print Cotton
          '8372764803236',    // 45 · White Indigo Ethnic Motifs Print
          '8734148329636',    // 47 · Indigo Red Ethnic Print
          '8734148133028',    // 50 · Peach Multi Ethnic Print
          '10267450343588',   // 53 · Mustard Ethnic Print Cotton Top
          '10267450212516',   // 54 · Fuchsia Floral Print Cotton Top
          '8739722166436',    // 57 · Maroon Ethnic Printed
          '10191519973540'    // 60 · Pink Multi Floral Printed
        ],

        lowstock: [
          '8264720318628',    // 13 · Light Pink Ethnic Print
          '8372764868772',    // 15 · Indigo Red Ethnic Motifs Print
          '8525667729572',    // 16 · Pink Multi Floral Print
          '8162229551268',    // 20 · Indigo Cotton Floral Printed
          '10191519842468',   // 21 · Mustard Multi Floral Print
          '8734148296868',    // 25 · Black Brown Ethnic Print
          '10288378839204',   // 26 · Rust Geometric Print
          '10344312111268',   // 31 · Beige Maroon Geometric Print Cotton
          '10191520006308',   // 32 · Grey Milange Floral Print
          '8162229584036',    // 37 · Mustard Multi Cotton Floral Print
          '8372764836004',    // 38 · Rust Multi Ethnic Print
          '10258733334692',   // 42 · Black Stretch Waist Trouser
          '8734148362404',    // 46 · Mustard Taupe Ethnic Print
          '10191519908004',   // 48 · Burgundy Floral Print
          '8734148427940',    // 49 · Indigo Red Ethnic Printed
          '10288378445988',   // 52 · Grey Teal Ethnic Print
          '8602183598244',    // 55 · Red Mustard Ethnic Print
          '10267449295012',   // 56 · Black High-Rise Trouser
          '10191519940772',   // 58 · Olive Green Floral Print
          '10288378478756'    // 59 · Red Grey Ethnic Print
        ]

      },

      /* ══ NARROW A SINGLE LABEL TO CERTAIN COLLECTIONS ══
         Collection IDs. Empty = every collection in ALLOWED_IDS. */
      LABEL_COLLECTIONS: {
        bestseller: [],
        soldout:    [],
        new:        [],
        lowstock:   []
      },

      PRIORITY: ['bestseller', 'soldout', 'lowstock', 'new'],

      /* ══ PERFORMANCE (MATCH_BY 'id' only) ══ */
      CACHE_MINUTES: 30,
      MAX_CONCURRENT: 4,

      /* ══ LABEL STYLES ══
         img '' = plain pill. Mobile fields '' = reuse desktop. */
      LABELS: {
        bestseller: {
          text: 'Bestseller', img: '',
          color: '#ffffff', bg: '#3D0F22',
          colorMobile: '', bgMobile: ''
        },
        soldout: {
          text: 'Sold Out', img: '',
          color: '#ffffff', bg: '#6b6b6b',
          colorMobile: '', bgMobile: ''
        },
        new: {
          text: 'New Arrival', img: '',
          color: '#ffffff', bg: '#3D0F22',
          colorMobile: '', bgMobile: ''
        },
        lowstock: {
          text: 'Few Left', img: '',
          color: '#ffffff', bg: '#3D0F22',
          colorMobile: '', bgMobile: ''
        }
      },

      /* ══ WHERE THE LABEL SITS ══
         'beside-badge' | 'below-badge' | 'top-left' |
         'top-right'    | 'bottom-left' | 'bottom-right'        */
      ANCHOR_DESKTOP: 'beside-badge',
      ANCHOR_MOBILE:  'beside-badge',

      OFFSET_DESKTOP: { TOP: '2%', RIGHT: '4%', LEFT: '4%', BOTTOM: '4%' },
      OFFSET_MOBILE:  { TOP: '2%', RIGHT: '3%', LEFT: '3%', BOTTOM: '3%' },

      MOBILE_BREAKPOINT: '749px',

      /* ══ DISCOUNT BADGE SCALING ══ */
      SCALE_BADGE: true,

      BADGE_DESKTOP: {
        W_MIN: '38px', W_CQ: '29cqw', W_MAX: '70px',
        H_MIN: '24px', H_CQ: '19cqw', H_MAX: '45px',
        FS_MIN: '6px', FS_CQ: '3.9cqw', FS_MAX: '12px'
      },

      BADGE_MOBILE: {
        W_MIN: '34px', W_CQ: '30cqw', W_MAX: '60px',
        H_MIN: '22px', H_CQ: '20cqw', H_MAX: '38px',
        FS_MIN: '6px', FS_CQ: '4.2cqw', FS_MAX: '10px'
      },

      BADGE_W_FALLBACK: '70px',
      BADGE_H_FALLBACK: '45px',

      /* Space reserved on the left for the wishlist heart */
      WISHLIST_W_DESKTOP: '40px',
      WISHLIST_W_MOBILE:  '32px',

      /* ══ LABEL SIZING — clamp(MIN, CQW, MAX) ══ */
      DESKTOP: {
        GAP_MIN: '3px',   GAP_CQ: '2cqw',     GAP_MAX: '8px',
        TEXT_MIN: '5px',  TEXT_CQ: '4cqw',    TEXT_MAX: '12px',
        PAD_X_MIN: '3px', PAD_X_CQ: '2.8cqw', PAD_X_MAX: '10px',
        PAD_Y_MIN: '2px', PAD_Y_CQ: '1.6cqw', PAD_Y_MAX: '5px',
        IMG_W_MIN: '40px', IMG_W_CQ: '32cqw', IMG_W_MAX: '70px',
        IMG_H_MIN: '26px', IMG_H_CQ: '21cqw', IMG_H_MAX: '45px',
        RADIUS: '3px'
      },

      MOBILE: {
        GAP_MIN: '2px',   GAP_CQ: '2cqw',     GAP_MAX: '6px',
        TEXT_MIN: '5px',  TEXT_CQ: '4.2cqw',  TEXT_MAX: '10px',
        PAD_X_MIN: '3px', PAD_X_CQ: '3cqw',   PAD_X_MAX: '8px',
        PAD_Y_MIN: '2px', PAD_Y_CQ: '1.8cqw', PAD_Y_MAX: '4px',
        IMG_W_MIN: '34px', IMG_W_CQ: '33cqw', IMG_W_MAX: '60px',
        IMG_H_MIN: '22px', IMG_H_CQ: '22cqw', IMG_H_MAX: '38px',
        RADIUS: '3px'
      },

      /* Below this CARD width the label stacks under the badge.
         '' disables it.                                        */
      STACK_BELOW_AT: '175px',

      /* ══ TYPE ══ */
      FONT_FAMILY: '"Montserrat", sans-serif',
      WEIGHT:      '600',
      TRACKING:    '0.02em',
      UPPERCASE:   true,
      LINE_HEIGHT: '1.1',

      STICKER_TEXT_SHADOW: '0 1px 4px rgba(0,0,0,0.6)',

      FADE_MS: 240
    };

    var STYLE_ID  = 'c3599-product-label-styles-' + BUILD;
    var CACHE_KEY = 'c3599_prodcache_' + BUILD;
    var queue = [], active = 0, cache = null;

    function cl(min, mid, max) {
      return 'clamp(' + min + ',' + mid + ',' + max + ')';
    }

    /* Position rules for one anchor keyword */
    function anchorCSS(sel, anchor, off) {
      var I = ' !important;';
      var rules;

      if (anchor === 'below-badge') {
        rules =
          'top:calc(' + off.TOP + ' + var(--c3599-badge-h) + var(--c3599-gap))' + I +
          'right:' + off.RIGHT + I + 'left:auto' + I + 'bottom:auto' + I +
          'transform:none' + I + 'max-width:92%' + I;
      } else if (anchor === 'top-left') {
        rules = 'top:' + off.TOP + I + 'left:' + off.LEFT + I +
                'right:auto' + I + 'bottom:auto' + I + 'transform:none' + I;
      } else if (anchor === 'top-right') {
        rules = 'top:' + off.TOP + I + 'right:' + off.RIGHT + I +
                'left:auto' + I + 'bottom:auto' + I + 'transform:none' + I;
      } else if (anchor === 'bottom-left') {
        rules = 'bottom:' + off.BOTTOM + I + 'left:' + off.LEFT + I +
                'right:auto' + I + 'top:auto' + I + 'transform:none' + I;
      } else if (anchor === 'bottom-right') {
        rules = 'bottom:' + off.BOTTOM + I + 'right:' + off.RIGHT + I +
                'left:auto' + I + 'top:auto' + I + 'transform:none' + I;
      } else {
        /* beside-badge — no badge on this card = sit at the edge */
        rules =
          'top:calc(' + off.TOP + ' + (var(--c3599-badge-h) / 2))' + I +
          'right:' + off.RIGHT + I + 'left:auto' + I + 'bottom:auto' + I +
          'transform:translateY(-50%)' + I;
      }

      var out = sel + '{' + rules + '}';

      /* Reserve badge width ONLY when the card really has a badge */
      if (anchor === 'beside-badge') {
        out += '.c3599-has-badge ' + sel + '{' +
                 'right:calc(' + off.RIGHT + ' + var(--c3599-badge-w) + var(--c3599-gap))' + I +
                 'max-width:calc(100% - var(--c3599-badge-w) - var(--c3599-wishlist))' + I +
               '}';
      }

      return out;
    }

    function injectStyles() {
      if (document.getElementById(STYLE_ID)) return;

      var C = CONFIG, D = C.DESKTOP, M = C.MOBILE;
      var BD = C.BADGE_DESKTOP, BM = C.BADGE_MOBILE;

      var fsD   = cl(D.TEXT_MIN, D.TEXT_CQ, D.TEXT_MAX);
      var padXD = cl(D.PAD_X_MIN, D.PAD_X_CQ, D.PAD_X_MAX);
      var padYD = cl(D.PAD_Y_MIN, D.PAD_Y_CQ, D.PAD_Y_MAX);
      var imgWD = cl(D.IMG_W_MIN, D.IMG_W_CQ, D.IMG_W_MAX);
      var imgHD = cl(D.IMG_H_MIN, D.IMG_H_CQ, D.IMG_H_MAX);
      var gapD  = cl(D.GAP_MIN, D.GAP_CQ, D.GAP_MAX);
      var bWD   = cl(BD.W_MIN, BD.W_CQ, BD.W_MAX);
      var bHD   = cl(BD.H_MIN, BD.H_CQ, BD.H_MAX);
      var bFSD  = cl(BD.FS_MIN, BD.FS_CQ, BD.FS_MAX);

      var fsM   = cl(M.TEXT_MIN, M.TEXT_CQ, M.TEXT_MAX);
      var padXM = cl(M.PAD_X_MIN, M.PAD_X_CQ, M.PAD_X_MAX);
      var padYM = cl(M.PAD_Y_MIN, M.PAD_Y_CQ, M.PAD_Y_MAX);
      var imgWM = cl(M.IMG_W_MIN, M.IMG_W_CQ, M.IMG_W_MAX);
      var imgHM = cl(M.IMG_H_MIN, M.IMG_H_CQ, M.IMG_H_MAX);
      var gapM  = cl(M.GAP_MIN, M.GAP_CQ, M.GAP_MAX);
      var bWM   = cl(BM.W_MIN, BM.W_CQ, BM.W_MAX);
      var bHM   = cl(BM.H_MIN, BM.H_CQ, BM.H_MAX);
      var bFSM  = cl(BM.FS_MIN, BM.FS_CQ, BM.FS_MAX);

      var BP = '@media (max-width:' + C.MOBILE_BREAKPOINT + ')';

      var css =

        /* The positioning context. Without this the absolutely
           positioned label escapes the card entirely. */
        '.pc-card .pc-img-wrap{' +
          'position:relative;' +
          'container-type:inline-size;' +
          'container-name:c3599card;' +
        '}' +

        /* base / desktop vars + hard structural rules */
        '.c3599-label{' +
          '--c3599-fs:clamp(6px,2vw,11px);' +
          '--c3599-pad-x:clamp(4px,1.5vw,10px);' +
          '--c3599-pad-y:clamp(2px,0.7vw,5px);' +
          '--c3599-img-w:clamp(40px,14vw,70px);' +
          '--c3599-img-h:clamp(26px,9vw,45px);' +
          '--c3599-gap:clamp(3px,1vw,8px);' +
          '--c3599-badge-w:' + C.BADGE_W_FALLBACK + ';' +
          '--c3599-badge-h:' + C.BADGE_H_FALLBACK + ';' +
          '--c3599-wishlist:' + C.WISHLIST_W_DESKTOP + ';' +
          '--c3599-radius:' + D.RADIUS + ';' +
          'position:absolute !important;' +
          'width:auto !important;' +
          'max-width:calc(100% - (' + C.OFFSET_DESKTOP.LEFT + ' * 2));' +
          'z-index:3 !important;pointer-events:none;' +
          'display:flex !important;align-items:center;justify-content:center;' +
          'opacity:0;' +
          'transition:opacity ' + C.FADE_MS + 'ms ease;' +
        '}' +
        '.c3599-label.is-in{opacity:1;}' +

        anchorCSS('.c3599-label', C.ANCHOR_DESKTOP, C.OFFSET_DESKTOP) +

        BP + '{' +
          '.c3599-label{' +
            '--c3599-wishlist:' + C.WISHLIST_W_MOBILE + ';' +
            '--c3599-radius:' + M.RADIUS + ';' +
          '}' +
          anchorCSS('.c3599-label', C.ANCHOR_MOBILE, C.OFFSET_MOBILE) +
        '}' +

        '@supports (container-type:inline-size){' +

          '@container c3599card (min-width:0px){' +
            '.c3599-label{' +
              '--c3599-fs:' + fsD + ';' +
              '--c3599-pad-x:' + padXD + ';' +
              '--c3599-pad-y:' + padYD + ';' +
              '--c3599-img-w:' + imgWD + ';' +
              '--c3599-img-h:' + imgHD + ';' +
              '--c3599-gap:' + gapD + ';' +
              (C.SCALE_BADGE
                ? '--c3599-badge-w:' + bWD + ';--c3599-badge-h:' + bHD + ';'
                : '') +
            '}' +
          '}' +

          /* Badge: width/height/font-size ONLY. */
          (C.SCALE_BADGE
            ? '@container c3599card (min-width:0px){' +
                '.pc-card .pc-badge-inner{width:' + bWD + ';height:' + bHD + ';}' +
                '.pc-card .pc-badge-text-on-img{font-size:' + bFSD + ';}' +
              '}'
            : '') +

          BP + '{' +
            '@container c3599card (min-width:0px){' +
              '.c3599-label{' +
                '--c3599-fs:' + fsM + ';' +
                '--c3599-pad-x:' + padXM + ';' +
                '--c3599-pad-y:' + padYM + ';' +
                '--c3599-img-w:' + imgWM + ';' +
                '--c3599-img-h:' + imgHM + ';' +
                '--c3599-gap:' + gapM + ';' +
                (C.SCALE_BADGE
                  ? '--c3599-badge-w:' + bWM + ';--c3599-badge-h:' + bHM + ';'
                  : '') +
              '}' +
            '}' +
            (C.SCALE_BADGE
              ? '@container c3599card (min-width:0px){' +
                  '.pc-card .pc-badge-inner{width:' + bWM + ';height:' + bHM + ';}' +
                  '.pc-card .pc-badge-text-on-img{font-size:' + bFSM + ';}' +
                '}'
              : '') +
          '}' +

          (C.STACK_BELOW_AT
            ? '@container c3599card (max-width:' + C.STACK_BELOW_AT + '){' +
                '.c3599-has-badge .c3599-label{' +
                  'top:calc(' + C.OFFSET_MOBILE.TOP + ' + var(--c3599-badge-h) + 3px) !important;' +
                  'right:' + C.OFFSET_MOBILE.RIGHT + ' !important;' +
                  'left:auto !important;bottom:auto !important;' +
                  'transform:none !important;max-width:92% !important;' +
                  '--c3599-fs:clamp(6px,5.5cqw,9px);' +
                '}' +
              '}'
            : '') +

        '}' +

        '.c3599-label--sticker{' +
          'width:var(--c3599-img-w) !important;height:var(--c3599-img-h);' +
        '}' +

        '.c3599-label-img{' +
          'position:absolute;top:0;left:0;' +
          'width:100%;height:100%;object-fit:contain;' +
          'display:block;z-index:1;' +
        '}' +

        '.c3599-label-text{' +
          'position:absolute;top:50%;left:50%;' +
          'transform:translate(-50%,-50%);' +
          'z-index:2;width:90%;text-align:center;' +
          'font-family:' + C.FONT_FAMILY + ';' +
          'font-size:var(--c3599-fs);' +
          'font-weight:' + C.WEIGHT + ';' +
          'letter-spacing:' + C.TRACKING + ';' +
          'text-transform:' + (C.UPPERCASE ? 'uppercase' : 'none') + ';' +
          'line-height:' + C.LINE_HEIGHT + ';white-space:nowrap;' +
          'text-shadow:' + C.STICKER_TEXT_SHADOW + ';' +
        '}' +

        '.c3599-label--pill{' +
          'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' +
          'font-family:' + C.FONT_FAMILY + ';' +
          'padding:var(--c3599-pad-y) var(--c3599-pad-x);' +
          'border-radius:var(--c3599-radius);' +
          'font-size:var(--c3599-fs);' +
          'font-weight:' + C.WEIGHT + ';' +
          'letter-spacing:' + C.TRACKING + ';' +
          'text-transform:' + (C.UPPERCASE ? 'uppercase' : 'none') + ';' +
          'line-height:' + C.LINE_HEIGHT + ';' +
        '}' +

        '@media (prefers-reduced-motion: reduce){' +
          '.c3599-label{transition:none;opacity:1;}' +
        '}';

      /* Per-label colours, desktop + mobile */
      Object.keys(C.LABELS).forEach(function (key) {
        var d = C.LABELS[key];
        if (d.img) return;
        css += '.c3599-label--' + key + '{background:' + d.bg + ';color:' + d.color + ';}';
        if (d.bgMobile || d.colorMobile) {
          css += BP + '{.c3599-label--' + key + '{' +
                   (d.bgMobile    ? 'background:' + d.bgMobile + ';' : '') +
                   (d.colorMobile ? 'color:' + d.colorMobile + ';'   : '') +
                 '}}';
        }
      });

      var tag = document.createElement('style');
      tag.id = STYLE_ID;
      tag.appendChild(document.createTextNode(css));
      document.head.appendChild(tag);
    }

    /* ── sessionStorage cache (id mode only) ── */
    function loadCache() {
      if (cache) return cache;
      try {
        var raw = sessionStorage.getItem(CACHE_KEY);
        var obj = raw ? JSON.parse(raw) : {};
        var cutoff = Date.now() - (CONFIG.CACHE_MINUTES * 60000);
        Object.keys(obj).forEach(function (k) {
          if (!obj[k] || obj[k].t < cutoff) delete obj[k];
        });
        cache = obj;
      } catch (e) { cache = {}; }
      return cache;
    }

    function saveCache() {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache || {})); }
      catch (e) {}
    }

    function clearCache() {
      cache = {};
      try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {}
    }

    function labelAllowedHere(key) {
      var list = CONFIG.LABEL_COLLECTIONS[key];
      if (!list || !list.length) return true;
      var id = pageInfo().id;
      if (!id) return false;
      for (var i = 0; i < list.length; i++) {
        if (String(list[i]).trim() === String(id).trim()) return true;
      }
      return false;
    }

    function labelFor(value) {
      if (value === null || value === undefined || value === '') return null;
      var want = String(value).trim().toLowerCase();

      for (var p = 0; p < CONFIG.PRIORITY.length; p++) {
        var key  = CONFIG.PRIORITY[p];
        var list = CONFIG.ASSIGN[key] || [];
        for (var i = 0; i < list.length; i++) {
          if (String(list[i]).trim().toLowerCase() === want) {
            return labelAllowedHere(key) ? key : null;
          }
        }
      }
      return null;
    }

    /* ── Render ── */
    function render(card, key) {
      if (!collectionAllowed()) return;          // ← final gate
      if (!key || !CONFIG.LABELS[key]) return;

      var wrap = card.querySelector('.pc-img-wrap');
      if (!wrap) return;
      if (wrap.querySelector('.c3599-label')) return;

      /* Never render before the stylesheet exists */
      injectStyles();

      /* Belt and braces on the positioning ancestor */
      if (getComputedStyle(wrap).position === 'static') {
        wrap.style.position = 'relative';
      }

      /* Reserve badge room only if a badge exists on THIS card */
      var hasBadge = !!wrap.querySelector('.pc-badge-inner, .pc-discount-badge');
      if (hasBadge) wrap.classList.add('c3599-has-badge');

      var def = CONFIG.LABELS[key];
      var el  = document.createElement('div');

      el.className = 'c3599-label c3599-label--' + key +
                     (def.img ? ' c3599-label--sticker' : ' c3599-label--pill');

      /* Inline structural styles — even with no stylesheet at all,
         this can never render as a full-width block bar. */
      el.style.position = 'absolute';
      el.style.width = 'auto';
      el.style.zIndex = '3';
      el.style.pointerEvents = 'none';
      el.style.display = 'flex';
      el.style.alignItems = 'center';
      el.style.justifyContent = 'center';

      if (def.img) {
        var img = document.createElement('img');
        img.className = 'c3599-label-img';
        img.src = def.img;
        img.alt = '';
        img.loading = 'lazy';
        el.appendChild(img);

        var txt = document.createElement('span');
        txt.className = 'c3599-label-text';
        txt.style.color = def.color;
        txt.textContent = def.text;
        el.appendChild(txt);
      } else {
        el.textContent = def.text;
      }

      wrap.appendChild(el);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.classList.add('is-in'); });
      });
    }

    /* ── Throttled fetch queue (id mode only) ── */
    function pump() {
      while (active < CONFIG.MAX_CONCURRENT && queue.length) {
        (function (job) {
          active++;
          fetch('/products/' + job.handle + '.js', {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              if (!data) { log('fetch empty for', job.handle); return; }
              var key = labelFor(data.id);
              log(job.handle, 'id:', data.id, '→', key || '(none)');
              loadCache()[job.handle] = { t: Date.now(), k: key };
              saveCache();
              if (key) render(job.card, key);
            })
            .catch(function (e) { log('fetch failed for', job.handle, e); })
            .finally(function () { active--; pump(); });
        })(queue.shift());
      }
    }

    function processCard(card) {
      if (!collectionAllowed()) return;          // ← gate
      if (!card || card._c3599LabelDone) return;
      card._c3599LabelDone = true;

      var handle = card.getAttribute('data-handle');
      if (!handle) return;

      if (CONFIG.MATCH_BY === 'handle') {
        var key = labelFor(handle);
        log(handle, '→', key || '(none)');
        if (key) render(card, key);
        return;
      }

      var hit = loadCache()[handle];
      if (hit) {
        log('cache hit', handle, '→', hit.k || '(none)');
        if (hit.k) render(card, hit.k);
        return;
      }

      queue.push({ handle: handle, card: card });
      pump();
    }

    /* ── Lazy: only cards that scroll into view ── */
    var io = null;

    function observeCard(card) {
      if (!collectionAllowed()) return;          // ← gate
      if (!card || card._c3599LabelWatched) return;
      card._c3599LabelWatched = true;

      if (CONFIG.MATCH_BY === 'handle') { processCard(card); return; }
      if (!('IntersectionObserver' in window)) { processCard(card); return; }

      if (!io) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.unobserve(en.target);
            processCard(en.target);
          });
        }, { rootMargin: '200px 0px' });
      }
      io.observe(card);
    }

    function scan(target) {
      if (!collectionAllowed()) return;          // ← gate
      if (!target || target.nodeType !== 1) return;

      if (target.classList && target.classList.contains('pc-card')) {
        observeCard(target);
        return;
      }

      if (!target.querySelectorAll) return;
      var cards = target.querySelectorAll('.pc-card[data-handle]');
      for (var i = 0; i < cards.length; i++) observeCard(cards[i]);
    }

    function init() {
      if (!collectionAllowed()) return;          // ← gate
      injectStyles();
      scan(document.body);
    }

    /* ── Manual diagnostic ── */
    function debugAll() {
      var cards = document.querySelectorAll('.pc-card[data-handle]');
      if (!cards.length) { console.log('[C3599] no cards found'); return; }

      var assigned = 0;
      Object.keys(CONFIG.ASSIGN).forEach(function (k) {
        assigned += (CONFIG.ASSIGN[k] || []).length;
      });

      if (CONFIG.MATCH_BY === 'handle') {
        var rows = [];
        Array.prototype.forEach.call(cards, function (c) {
          var h = c.getAttribute('data-handle');
          rows.push({ handle: h, label: labelFor(h) || '(none)' });
        });
        console.table(rows);
        console.log('MATCH_BY: handle | products assigned:', assigned);
        return;
      }

      var out = [], left = cards.length;
      Array.prototype.forEach.call(cards, function (c) {
        var h = c.getAttribute('data-handle');
        fetch('/products/' + h + '.js')
          .then(function (r) { return r.json(); })
          .then(function (p) {
            out.push({ handle: h, productId: String(p.id), label: labelFor(p.id) || '(none)' });
          })
          .catch(function () { out.push({ handle: h, label: 'FETCH FAILED' }); })
          .finally(function () {
            if (--left === 0) {
              console.table(out);
              console.log('MATCH_BY: id | products assigned:', assigned);
            }
          });
      });
    }

    return {
      init: init, scan: scan, debug: debugAll,
      clearCache: clearCache, config: CONFIG
    };
  })();


  /* ════════════════════════════════════════════════════════════
     SHARED — DOM OBSERVER
     ------------------------------------------------------------
     Never started on a blocked collection. Scoped to the grid,
     childList only, and skips anything inside .pc-discount-badge
     — product-card.js retypes that text on a perpetual timer.
     ════════════════════════════════════════════════════════════ */
  var observers = [];

  function scanAll(target) {
    if (!collectionAllowed()) return;            // ← gate
    try { U1.scan(target); } catch (e) { console.warn('[C3599] U1 scan failed', e); }
    try { U2.scan(target); } catch (e) { console.warn('[C3599] U2 scan failed', e); }
  }

  function isNoise(node) {
    if (!node || node.nodeType !== 1) return true;
    if (node.closest && node.closest('.pc-discount-badge, .c3599-label')) return true;
    if (node.classList && (
        node.classList.contains('c3599-label') ||
        node.classList.contains('pc-badge-typing'))) return true;
    return false;
  }

  function observeTarget(host) {
    if (!host || host._c3599Observed) return;
    host._c3599Observed = true;

    var pending = false;
    var queued  = [];

    var flush = function () {
      pending = false;
      var nodes = queued.splice(0, queued.length);
      if (!collectionAllowed()) return;          // ← gate
      nodes.forEach(scanAll);
    };

    var mo = new MutationObserver(function (mutations) {
      var hit = false;

      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'childList') continue;
        if (isNoise(m.target)) continue;

        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (isNoise(n)) continue;
          queued.push(n);
          hit = true;
        }
      }

      if (hit && !pending) {
        pending = true;
        requestAnimationFrame(flush);
      }
    });

    mo.observe(host, { childList: true, subtree: true });
    observers.push(mo);
  }

  function startObservers() {
    if (!collectionAllowed()) return;            // ← gate
    var hosts = document.querySelectorAll('[data-mc-grid-container], [data-mc-grid]');
    if (hosts.length) {
      for (var i = 0; i < hosts.length; i++) observeTarget(hosts[i]);
    } else {
      observeTarget(document.querySelector('.mc-root') || document.body);
    }
  }


  /* ════════════════════════════════════════════════════════════
     BOOT
     ════════════════════════════════════════════════════════════ */
  function init() {
    if (!collectionAllowed()) return;            // ← gate
    log('booting', BUILD);

    try { U1.init(); } catch (e) { console.warn('[C3599] U1 init failed', e); }
    try { U2.init(); } catch (e) { console.warn('[C3599] U2 init failed', e); }

    startObservers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── AJAX sort / filter / pagination ──
     THIS is where v6 leaked. Every handler now gates first. */
  function onSectionUpdate() {
    if (!collectionAllowed()) return;            // ← gate
    scanAll(document.body);
    startObservers();
  }

  [
    'mc:products-updated',
    'mc:section-updated',
    'mc:filters-updated',
    'mc:grid-updated',
    'shopify:section:load'
  ].forEach(function (evt) {
    document.addEventListener(evt, onSectionUpdate);
  });

  window.Collection3599 = {
    build: BUILD,
    init: init,
    scan: scanAll,
    debug: function () { U2.debug(); },
    clearCache: function () { U2.clearCache(); },
    where: function () {
      var p = pageInfo();
      gateAnnounced = true;   // don't double-print while inspecting
      var allowed = (function () {
        if (p.type && p.type !== 'collection') return false;
        if (!p.id) return false;
        for (var i = 0; i < GATE.ALLOWED_IDS.length; i++) {
          if (String(GATE.ALLOWED_IDS[i]).trim() === String(p.id).trim()) return true;
        }
        return false;
      })();
      console.table([{
        build:        BUILD,
        pageType:     p.type || '(none)',
        collectionId: p.id   || '(none)',
        inAllowedIds: allowed,
        labelsOnPage: document.querySelectorAll('.c3599-label').length
      }]);
      return p;
    },
    gate:   GATE,
    config: U2.config,
    noteConfig: U1.config
  };
})();